import { useSplide } from '~/lib/splide'

document.addEventListener('DOMContentLoaded', () => {
  console.log("slider mounted");

  // main slider
  useSplide('.slider__delivered', {
    perPage: 1,
    perMove: 1,
    arrows: false,
		gap: '1rem',
		pagination: false,
  })
    ?.then((splideDelivered) => {
      splideDelivered?.mount();

      // thumbnails slider
      useSplide('.slider__thumbnails', {
        perPage: 3.4,
        perMove: 1,
				gap: '0.2rem',
        isNavigation: true,
        arrows: true
      })
        ?.then((splideThumbnail) => {
          splideThumbnail?.mount();

          // Sync
          if (splideDelivered && splideThumbnail) {
            splideDelivered.sync(splideThumbnail);
          }
        });
    });
});